import { MapContainer, Marker, TileLayer } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import styles from "./Map.module.css";
import markerIconPng from "leaflet/dist/images/marker-icon.png";

interface IMapLocation {
  lat: number;
  lng: number;
}

const customIcon = new L.Icon({
  iconUrl: markerIconPng,
  iconSize: [25, 41],
  iconAnchor: [12, 41]
});
export default function Map({ lat, lng }: IMapLocation) {
  const position: [number, number] = [
    Number(lat) || 39.9255,
    Number(lng) || 32.8663
  ];

  return (
    <MapContainer
      center={position}
      zoom={13}
      scrollWheelZoom={false}
      className={styles.MapContainer}
    >
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      <Marker position={position} icon={customIcon}></Marker>
    </MapContainer>
  );
}
